import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';

/**
 * https://github.com/mahpah/dgm-ng2-redactor/blob/master/src/redactor.component.ts
 */
@Component({
  selector: 'app-redactor-field',
  // https://github.com/froala/angular-froala-wysiwyg/blob/master/src/editor/editor.directive.ts
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RedactorFieldComponent),
    multi: true
  } ],
  templateUrl: './redactor-field.component.html',
  styleUrls: ['./redactor-field.component.css']
})
export class RedactorFieldComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  private readonly defaultRedactorOptions = {
    lang: 'ru',
    linkNofollow: true,
    // fileUpload: '/redactor/upload/file/',
    // imageUpload: '/redactor/upload/image/',
  };

  @Input() redactorOptions = {};
  private _onChange: Function;
  private _onTouched: Function;
  @ViewChild('content') private content: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.initRedactor();
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (typeof this._onChange === 'function') {
        const cb = this._onChange;
        $(this.content.nativeElement).on({
          'change.callback.redactor': function () {
            cb(this.code.get());
          }
        });
      }
    }
  }

  writeValue(value) {
    if (isPlatformBrowser(this.platformId)) {
      $(this.content.nativeElement).redactor('code.set', value);
    }
  }

  registerOnChange(fn) {
    this._onChange = fn;
  }

  registerOnTouched(fn) {
    this._onTouched = fn;
  }

  // setDisabledState(isDisabled: boolean): void {
  // }

  private initRedactor() {
    const config = {
      ...this.defaultRedactorOptions,
      ...this.redactorOptions,
    };

    $(this.content.nativeElement).redactor(config);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/redactor-field/redactor-field.component.ts